import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route } from 'react-router-dom'; // Changed to react-router-dom
import { Layout } from './components/Layout';
import { RequestLogs } from './pages/RequestLogs';
import { Home } from './pages/Home';
import { Details } from './pages/Details';
import { TestResult } from './pages/TestResult';
import { Sender } from './pages/Sender';
import { Provider } from "react-redux";
import store from "./store";
import './custom.css';

export default function App() {
    return (
        <Provider store={store}>
            <Layout>
                <Route exact path='/' component={Home} />
                <Route exact path='/home' component={Home} />
                <Route path='/logs' component={RequestLogs} />
                <Route path='/details' component={Details} />
                <Route path='/testResult' component={TestResult} />
                <Route path='/sender' component={Sender} />
            </Layout>
        </Provider>
    );
}